import React from 'react'
import { IoArrowForwardSharp } from 'react-icons/io5';

const AboutUsHeader = () => {
  return (
    <>
      <section className="section-with-120px-margin">
        <div className="container">
          <div className="_2-column-block">
            <div className="double-image-wrapper">
              <img
                src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232606/caldera-pool_naneho_w9xuzp.jpg"
                loading="lazy"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
                data-w-id="83145ab1-f0b3-1865-afb0-ca4da4f0b351"
                alt=""
                className="image-65"
              />
              <img
                src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a8c77bb06b7704a261b3_Group%201000008415.avif"
                loading="lazy"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
                data-w-id="23d5db3c-edff-0513-f819-9d8fa9a36bc0"
                alt=""
                className="image-187px-absolute"
              />
              <img
                src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232605/1_gl67iz_ghjtp1.png"
                loading="lazy"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
                data-w-id="9f906a7d-6a9b-9a6b-3e6b-83039a07e91b"
                alt=""
                className="border-image-absolute"
              />
            </div>
            <div
              className="contents bg-bottom"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
            >
              <div
                className="fancy-title-20px"
                style={{
                  opacity: 1,
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
              >
                About Us
              </div>
              <div className="margin-top-10px-bottom-20px">
                <h2>Your gateway to amazing experiences</h2>
              </div>
              <p>
                We have been operating for over a decade, providing top-notch
                services to our clients and building a strong track record
              </p>
              <div className="w-layout-vflex list-item">
                <div className="horizontal-left-center-10px-gap">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                    loading="lazy"
                    alt=""
                    className="image-25px"
                  />
                  <div className="_18px-text-600">
                    Adventure awaits around every corner
                  </div>
                </div>
                <div className="horizontal-left-center-10px-gap">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                    loading="lazy"
                    alt=""
                    className="image-25px"
                  />
                  <div className="_18px-text-600">Roam free, wander often</div>
                </div>
                <div className="horizontal-left-center-10px-gap">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a405410e4b22f9acd0b3_%EF%81%BC.png"
                    loading="lazy"
                    alt=""
                    className="image-25px"
                  />
                  <div className="_18px-text-600">
                    Create memories that last a lifetime
                  </div>
                </div>
              </div>
              <div className="w-layout-hflex logo-list-counter">
                <div className="w-layout-hflex _10px-gap">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a6938d8b59f2c7283b36_026-schedule.svg"
                    loading="lazy"
                    alt=""
                    className="image-40px"
                  />
                  <div className="w-layout-vflex _10px-gap">
                    <h3 className="_32px-text">1000+</h3>
                    <p className="_20px-text">
                      Happy <br />
                      Customer
                    </p>
                  </div>
                </div>
                <div className="w-layout-hflex _10px-gap">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a69363b6e3f97282d820_011-dish.svg"
                    loading="lazy"
                    alt=""
                    className="image-40px"
                  />
                  <div className="w-layout-vflex _10px-gap">
                    <h3 className="_32px-text">300+</h3>
                    <p className="_20px-text">
                      Destinations <br />
                      Collaboration
                    </p>
                  </div>
                </div>
                <div className="w-layout-hflex _10px-gap">
                  <img
                    src="https://cdn.prod.website-files.com/66b5d6635ee4014275999ec3/66b9a6938689b891a24f5e53_018-beach.svg"
                    loading="lazy"
                    alt=""
                    className="image-40px"
                  />
                  <div className="w-layout-vflex _10px-gap">
                    <h3 className="_32px-text">30+</h3>
                    <p className="_20px-text">
                      Years <br />
                      Experience
                    </p>
                  </div>
                </div>
              </div>
              <a
                data-w-id="ba2560af-a813-130c-b209-b41d37b4cd90"
                href="/tour"
                className="secondary-button w-inline-block"
              >
                <div className="button-text-wrapper">
                  <div className="default-text">Find Tours</div>
                  <div className="hover-text">Find Tours</div>
                </div>
                <div className="button-icon">
                  <IoArrowForwardSharp />
                </div>

                <div
                  className="button-hover-reverse"
                  style={{
                    width: "100%",
                  }}
                ></div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUsHeader
